/**
 * MAT contact log — types for the "Contactar utente" flow.
 * Maps to backend EzfyAPI.Api/Models/DTOs/{Create,MatContactLogDto}.cs and the
 * EzfyAPI route /api/Patients/{accountId}/contacts.
 */

export type MatContactChannel =
  | 'Call'
  | 'Email'
  | 'Task'
  | 'Presencial'
  | 'SMS'
  | 'Outro';

export type MatContactOutcome =
  | 'Contacto efetuado'
  | 'Sem resposta'
  | 'Número inválido'
  | 'Reagendado'
  | 'Recusou falar'
  | 'Outro';

export interface CreateMatContactLogPayload {
  channel: MatContactChannel;
  outcome: MatContactOutcome;
  observations?: string;
  teamMemberId?: string;
}

export interface MatContactLog {
  id: string;
  createdDate: string | null;
  ownerName: string | null;
  channel: string | null;
  outcome: string | null;
  observations: string | null;
}

export interface MatContactLogPage {
  items: MatContactLog[];
  total: number;
  page: number;
  pageSize: number;
}

export interface CreateMatContactLogResponse {
  id: string;
  createdDate: string | null;
}

export interface MatContactChannelOption {
  readonly value: MatContactChannel;
  readonly label: string;
}

export interface MatContactOutcomeOption {
  readonly value: MatContactOutcome;
  readonly label: string;
}

// Channels offered for NEW contact-log entries. `Task` is intentionally excluded: it carries no
// clinical meaning as a contact channel (it only ever existed because it mirrors a native SF
// TaskSubtype value). For rendering legacy `Task` rows, use MAT_CONTACT_CHANNEL_LABELS below.
export const MAT_CONTACT_CHANNEL_OPTIONS: ReadonlyArray<MatContactChannelOption> = [
  { value: 'Call',       label: 'Chamada' },
  { value: 'SMS',        label: 'SMS' },
  { value: 'Email',      label: 'Email' },
  { value: 'Presencial', label: 'Presencial' },
  { value: 'Outro',      label: 'Outro' }
];

// Display labels for ALL channel values, including the retired `Task` → "Tarefa" mapping kept so
// historical contact-log rows (stored before `Task` was removed) still render with their original
// label. This is a superset of the selectable options above and MUST NOT be used to build dropdowns.
export const MAT_CONTACT_CHANNEL_LABELS: Readonly<Record<string, string>> = {
  Call: 'Chamada',
  Email: 'Email',
  Task: 'Tarefa',
  Presencial: 'Presencial',
  SMS: 'SMS',
  Outro: 'Outro'
};

export const MAT_CONTACT_OUTCOME_OPTIONS: ReadonlyArray<MatContactOutcomeOption> = [
  { value: 'Contacto efetuado', label: 'Contacto efetuado' },
  { value: 'Sem resposta',      label: 'Sem resposta' },
  { value: 'Número inválido',   label: 'Número inválido' },
  { value: 'Reagendado',        label: 'Reagendado' },
  { value: 'Recusou falar',     label: 'Recusou falar' },
  { value: 'Outro',             label: 'Outro' }
];
